import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useLocalization } from 'localization/useLocalization';
import { RecordContext } from 'shared/records/RecordContext';
import { QuickFilter } from '../DailyReceiptsList';
import { SelectableColumn } from '../SelectableColumn';
import { createColumnRecord } from '../utils/createColumnRecord';
import { createExportRecord } from '../utils/createExportRecord';
import { createHeaders } from '../utils/createHeaders';
import { createQfRecord } from '../utils/createQfRecord';
import { ViewContext } from './ViewContext';
import { QueryContext } from './QueryContext';
import { onResetToPage1 } from 'framework/types/onResetToPage1';
import { useParamsFromQueryContext } from 'framework/hooks/useParamsFromQueryContext';

// enkel hier nodig
const DefaultColumns: SelectableColumn[] = ['onDate', 'locationIdentifier', 'priceInVat', 'priceInVatAt0', 'priceInVatAt6', 'priceInVatAt9', 'priceInVatAt21'];

export const ViewProvider = ({ children }: any) => {
	const { saleTypeRecord } = useContext(RecordContext);
	const strings = useLocalization();
	const [qf, setQf] = useState<QuickFilter>('location');
	const [columns, setColumns] = useState<SelectableColumn[]>(DefaultColumns);
	const colRecord = useMemo(() => createColumnRecord(strings), [strings]);
	const headers = useMemo(() => createHeaders(colRecord, saleTypeRecord, strings), [colRecord, saleTypeRecord, strings]);
	const quickFilterRecord = useMemo(() => createQfRecord(strings), [strings]);
	const exportRecord = useMemo(() => createExportRecord(strings), [strings]);
	const { setParams } = useParamsFromQueryContext(QueryContext);

	useEffect(() => {
		setParams(params =>
			onResetToPage1({
				...params,
				isGlobal: qf === 'global' ? true : false,
				locationIds: [],
			})
		);
		// eslint-disable-next-line
	}, [qf]);

	return (
		<ViewContext.Provider
			value={{
				columns: columns,
				columnsRecord: colRecord,
				headers: headers,
				setColumns: setColumns,
				quickFilter: qf,
				setQuickFilter: setQf,
				quickFilterRecord: quickFilterRecord,
				exportRecord: exportRecord,
			}}>
			{children}
		</ViewContext.Provider>
	);
};
